<div nz-row class="intelligence-suite-content">
  <div nz-col nzSm="24" nzXs="24" nzMd="24" nzLg="24" nzXl="24">
    <nz-card [nzBordered]="true" nzTitle="" class="form-first-card">
      <!--<div nz-row nzJustify="space-between">
        <img nz-col class="intelligence-suite-cargoes-logo" nzSm="18" nzXs="18" nzMd="16" nzLg="16" nzXl="16"
          height="3%" src="../../../../assets/img/logo.png" alt="cargoeslogo" class="img-responsive">
        <div nz-col class="intelligence-suite-language" nzSm="4" nzXs="4" nzMd="8" nzLg="8" nzXl="8">
          <header-i18n [showLangText]="true" class="langs"></header-i18n>
        </div>
      </div>-->

      <div nz-row class="app-title">
        <span>{{'app.label.welcome.intelligence-suite' | translate}}</span>
      </div>
      <p nz-row class="intelligence-suite-tittle-desc">{{'app.login.title' | translate}}</p>
      <nz-divider style="margin: 0"></nz-divider>
      <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()" nzLayout="vertical">
        <nz-form-item nz-row>
          <nz-form-label><span class="color-white">{{ "app.label.username" | translate }}</span></nz-form-label>
          <nz-form-control [nzErrorTip]="'app.login.username.required' | translate">
            <nz-input-group [nzPrefix]="prefixUser">
              <input type="text" nz-input formControlName="userName"
                placeholder="{{ 'app.label.username' | translate }}" [nzSize]="'large'" autocomplete="off" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item nz-row>
          <nz-form-label><span class="color-white">{{ "app.label.password" | translate }}</span></nz-form-label>
          <nz-form-control [nzErrorTip]="'app.login.password.required' | translate">
            <nz-input-group [nzPrefix]="prefixLock" [nzSuffix]="suffixTemplate">
              <input [nzSize]="'large'" [type]="passwordVisible ? 'text' : 'password'" nz-input
                placeholder="{{ 'app.label.password' | translate }}" formControlName="password" autocomplete="off" />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                (click)="passwordVisible = !passwordVisible"></i>
            </ng-template>
          </nz-form-control>
          <a class="text-right display-block w100" (click)="forgotpassword()"><span >{{
              "app.login.forgotpassword" | translate
              }}</span></a>
        </nz-form-item>
        <nz-form-item class="mb0" nz-col>
          <nz-form-control>
            <button nz-button [nzSize]="'large'" [nzType]="'primary'" style="width: 100%; float: left" (click)="goto()"
              [nzLoading]="loading">
              {{ "app.label.signin" | translate }}
            </button>
          </nz-form-control>
        </nz-form-item>
      </form>

      <ng-template #prefixUser><i nz-icon nzType="user"></i></ng-template>
      <ng-template #prefixLock><i nz-icon nzType="lock"></i></ng-template>
    </nz-card>
  </div>
</div>
